import { render, staticRenderFns } from "./EllipseIcon.vue?vue&type=template&id=29dba353&scoped=true&"
import script from "./EllipseIcon.vue?vue&type=script&lang=js&"
export * from "./EllipseIcon.vue?vue&type=script&lang=js&"
import style0 from "./EllipseIcon.vue?vue&type=style&index=0&id=29dba353&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29dba353",
  null
  
)

export default component.exports